import React from "react";

import { ReactComponent as ApoteaLogoSvg } from "../../../images/apotea.svg";

import styles from "./Header.module.css";
import classNames from "classnames";
import { Button } from "semantic-ui-react";

type Props = { 
  isReviewMode: boolean,
  onLogout: () => void
};

const Header = ({ isReviewMode, onLogout }: Props) => {
  const classes = classNames(["control-app__header", styles["header"]]);
  const handleToggle = () => {
    const params = new URLSearchParams(window.location.search);
    const current = params.get("review") === "true";
    params.set("review", (!current).toString());
    const newUrl = `${window.location.pathname}?${params.toString()}`;
    window.history.replaceState({}, "", newUrl);
    window.location.reload();
  }
  return (
    <header className={classes}>
      <div className={styles["header__logo"]}>
        <ApoteaLogoSvg />
        <div className={styles["header__title-wrapper"]}>
          <h1>Kontrollstation</h1>
          {isReviewMode && <span>Sista kontrollstation</span>}
        </div>
        <div className={styles["flex-1"]}/>
        <Button onClick={handleToggle}>Byt kontrollstationsvy</Button>
        <Button onClick={onLogout} className="logout-button">Logga ut</Button>
      </div>
    </header>
  ); 
};

export default Header;

// <Dropdown item text="Display Options">
//   <DropdownMenu>
//     <DropdownHeader>Meny</DropdownHeader>
//     <DropdownItem>Logga ut</DropdownItem>
//     {/* <DropdownItem>Logga ut</DropdownItem> */}
//     {/* <DropdownItem>Medium</DropdownItem>
//     <DropdownItem>Large</DropdownItem> */}
//   </DropdownMenu>
// </Dropdown>;
